import { apiMain, apiUpload } from "services";
import { metrics } from "./metrics";
import sleep from "./sleep";

class GalleryStatusError extends Error {}

interface IProps {
  files: string[];
  tags: string[];
  niches: string[];
  publish: boolean;
  preferences: string;
}

export const createGallery = async (
  { files, tags, niches, publish, preferences }: IProps,
  progressCallback: Function
): Promise<string> => {
  const { id } = await apiUpload.createGallery({
    files, tags, niches, publish, preferences
  });
  await metrics.sendUploadStarted({ context: "create" });
  await metrics.sendUploadFinisher({});
  await checkUploadStatus(id, progressCallback);
  const gallery = await apiMain.getGallery(id);

  return gallery.gifs[0].id;
};

const checkUploadStatus = async (id: string, progressCallback: Function) => {
  let currentStatus;
  do {
    // eslint-disable-next-line
    const { status } = await apiUpload.checkUploadGalleryStatus(id);

    currentStatus = status;

    if (currentStatus === "error") {
      throw new GalleryStatusError("Error processing the file.");
    } else if (currentStatus === "complete") {
      break;
    } else {
      // progressCallback({
      //   percent: progress,
      //   duration: time,
      //   status: "Encoding..."
      // });
      // eslint-disable-next-line
      await sleep(1000);
    }
  } while (currentStatus === "encoding");
};
